import { jsx as e } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { P as p } from "./Pill-uAcQLotY.js";
const l = {
  draft: "neutral",
  active: "success",
  paused: "warning",
  paused_auto: "purple",
  finished: "info",
  error: "error"
}, m = n(
  function({ status: a, variant: r = "soft", size: t = "sm", children: i, ...o }, s) {
    return /* @__PURE__ */ e(
      p,
      {
        ref: s,
        tone: l[a],
        variant: r,
        size: t,
        "data-status": a,
        ...o,
        children: i
      }
    );
  }
);
m.displayName = "CampaignStatusPill";
export {
  m as C
};
//# sourceMappingURL=CampaignStatusPill-BgJs607o.js.map
